import { Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { type CmsArticle } from '@fcom/core-api';
import { type IconSet } from '@fcom/ui-components';

export interface Item {
  icon?: IconSet;
  title?: string;
  text?: string;
  changed?: boolean;
  article?: CmsArticle;
}

@Component({
  selector: 'fin-tier-benefits',
  templateUrl: './tier-benefits.component.html',
  styleUrls: ['./tier-benefits.component.scss'],
  standalone: false,
})
export class TierBenefitsComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() items: Item[];
  @Input() invertedColors = false;
}
